import { render, staticRenderFns } from "./PaidPercent.vue?vue&type=template&id=208d5988&scoped=true&"
import script from "./PaidPercent.vue?vue&type=script&lang=js&"
export * from "./PaidPercent.vue?vue&type=script&lang=js&"
import style0 from "./PaidPercent.vue?vue&type=style&index=0&id=208d5988&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208d5988",
  null
  
)

export default component.exports